import { Component, inject, signal } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { DotLoader } from './core/components/dot-loader/dot-loader';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, DotLoader],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  private router = inject(Router);

  protected readonly title = signal('gallus-admin-app');
  protected readonly navigating = signal(false);

  constructor() {
    this.router.events.pipe(
      filter(event =>
        event instanceof NavigationStart ||
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      )
    ).subscribe(event => this.navigating.set(event instanceof NavigationStart));
  }
}
